import { Space, Stack } from '@mantine/core';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
import { Button } from '../stories/Button/Button';
import { StyledStepper } from '../stories/Stepper/Stepper';
import { StyledDialog } from '../stories/StyledDialog/StyledDialog';
import { BottomSpacer, routeBasedOnStage, TopSpacer } from '../utils';

export function StepTwoView() {
  const { user } = useUserContext();

  if (user === null) {
    return <Navigate to={routeBasedOnStage('NOT_CREATED')} />;
  }

  const url = user.twitterAuthenticationLink || '';

  return (
    <Stack align="center" spacing={0}>
      <TopSpacer />
      <StyledStepper step={1} />
      <Space h={41} />
      <StyledDialog
        title="We gotta make sure you’re a human, part 1"
        description="We only request access to verify your username. You can revoke access at anytime."
        descriptionProps={{
          color: '#909296',
          size: 12
        }}
        children={
          <>
            <Space h={30} />
            <Button
              {...{
                label: 'Connect with Twitter',
                variant: 'twitter',
                toLink: url,
                external: true
              }}
            />
            <Space h={38} />
          </>
        }
      />
      <BottomSpacer />
    </Stack>
  );
}
